import React from 'react';
import '../styles/footer.css';

const FOOTER_LINKS = {
  'Company': [
    { label: 'About Us', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'Contact', href: '#contact' },
  ],
  'Services': [
    { label: 'Geotechnical Monitoring', href: '#services' },
    { label: 'Noise Monitoring', href: '#services' },
    { label: 'Vibration Monitoring', href: '#services' },
    { label: 'Structural Health Monitoring', href: '#services' },
    { label: 'IoT Sensor Networks', href: '#services' },
  ],
  'Platforms': [
    { label: 'IDMS Portal', href: '#solutions' },
    { label: 'Noise Monitoring System', href: '#solutions' },
  ],
};

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="cv-footer">
      <div className="cv-container">
        <div className="cv-footer__grid">
          <div className="cv-footer__brand">
            <div className="cv-footer__logo">
              <img src="/images/Corevision LOGO TRANSPARENT.png" alt="CoreVision Pte Ltd" style={{ height: '52px', width: 'auto', filter: 'brightness(0) invert(1)' }} />
            </div>
            <p className="cv-footer__tagline">
              Precision monitoring for Singapore's critical infrastructure, backed by strong engineering background and technical capability.
            </p>
            <div className="cv-footer__contact-brief">
              <p><span className="cv-footer__ci">📍</span> 65 Ubi Crescent, #03-05, Hola Centre, Singapore 408559</p>
              <p><span className="cv-footer__ci">☎</span> <a href="tel:+6568968926">+65 6896 8926</a> &nbsp;/&nbsp; <a href="tel:+6591689666">+65 9168 9666</a></p>
              <p><span className="cv-footer__ci">✉</span> <a href="mailto:enquire@corevision.com.sg">enquire@corevision.com.sg</a></p>
            </div>
            <div className="cv-footer__certs">
              <span className="cv-cert-badge">NEA Approved Real-Time Noise Monitoring Provider</span>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
            <div className="cv-footer__col" key={heading}>
              <h4 className="cv-footer__col-heading">{heading}</h4>
              <ul>
                {links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} onClick={(e) => handleNav(e, link.href)}>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="cv-footer__seo">
        <div className="cv-container">
          <p className="cv-footer__seo-text">
            Noise Monitoring Singapore &nbsp;|&nbsp; Vibration Monitoring Singapore &nbsp;|&nbsp; Geotechnical Monitoring Singapore &nbsp;|&nbsp; NEA-Compliant Monitoring Systems &nbsp;|&nbsp; Construction Site Monitoring Singapore
          </p>
        </div>
      </div>

      <div className="cv-footer__bottom">
        <div className="cv-container cv-footer__bottom-inner">
          <p>© {year} CoreVision Pte Ltd. All rights reserved. UEN: 202418575H</p>
          <p>
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="cv-footer__sep">·</span>
            <a href="/terms">Terms of Use</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

